import { SEGMENT_TTL } from "../../utils/dates";
export var RetargetingType;
(function (RetargetingType) {
    RetargetingType["TRACKING_PIXELS"] = "pixel";
    RetargetingType["CREATIVES"] = "creative";
    RetargetingType["CAMPAIGNS"] = "campaign";
    RetargetingType["LINE_ITEMS"] = "lineItems";
    /** Values are opaque vendor report ids, not mad keys. */
    RetargetingType["MEASUREMENT"] = "reportIds";
})(RetargetingType || (RetargetingType = {}));
export const RETARGETING_TYPE_NAMES = {
    [RetargetingType.TRACKING_PIXELS]: "Tracking Pixels",
    [RetargetingType.CREATIVES]: "Creatives",
    [RetargetingType.CAMPAIGNS]: "Campaigns",
    [RetargetingType.LINE_ITEMS]: "Line Items",
    [RetargetingType.MEASUREMENT]: "1P External Audiences"
};
export const serviceSegmentToSegment = (dmpSegment) => {
    const lastRefreshed = dmpSegment.bt_last_seen ? new Date(dmpSegment.bt_last_seen) : null;
    const lastModified = dmpSegment.last_seen ? new Date(dmpSegment.last_seen) : null;
    const hhCountUpdatedDate = dmpSegment.hh_reach_updated_at
        ? new Date(dmpSegment.hh_reach_updated_at)
        : null;
    const today = new Date().valueOf();
    const deriveLastRefreshedStatus = lastRefreshed && lastRefreshed.valueOf() > today - SEGMENT_TTL ? "Active" : "Expired";
    const segment = {
        id: dmpSegment.id,
        label: dmpSegment.name || "",
        price: dmpSegment.cpm / 100 || 0,
        householdCount: dmpSegment.reach || 0,
        householdCountUpdatedAt: hhCountUpdatedDate,
        externalId: dmpSegment.external_id || "",
        parent: dmpSegment.parent,
        status: dmpSegment.status || 0,
        initialProvider: dmpSegment.initial_provider,
        onboardingPath: dmpSegment.onboarding_path || "",
        lastRefreshed: lastRefreshed,
        lastModified: lastModified,
        lastRefreshedStatus: deriveLastRefreshedStatus,
        description: dmpSegment.description,
        createdBy: dmpSegment.created_by,
        createdOn: new Date(dmpSegment.created_on),
        preferred: !!dmpSegment.preferred,
        size: dmpSegment.size || 0,
        private: !!dmpSegment.private
    };
    if (dmpSegment.retargeting) {
        const retargetingType = Object.values(RetargetingType).find((type) => dmpSegment.retargeting[type]);
        const target = dmpSegment.retargeting[retargetingType];
        const retargetingWindow = dmpSegment.retargeting.retargetingWindow;
        const lineItemsCount = dmpSegment.number_of_associated_line_items || 0;
        /* Retargeting segments have no expiration **/
        return {
            ...segment,
            retargetingType,
            target,
            retargetingWindow,
            lineItemsCount,
            lastRefreshedStatus: "Active",
            lastModified: null,
            eventType: dmpSegment.retargeting.eventType,
            eventSubtype: dmpSegment.retargeting.eventSubtype,
            parameterFilters: dmpSegment.retargeting.parameterFilters,
            parameterFilterOperator: dmpSegment.retargeting.parameterFilterOperator
        };
    }
    return segment;
};
export const retargetingSegmentToRetargetingSegmentCreationPayload = (retargetingSegment) => {
    return {
        name: retargetingSegment.label,
        description: retargetingSegment.description,
        parent: retargetingSegment.parent,
        retargetingType: retargetingSegment.retargetingType,
        target: retargetingSegment.target,
        retargetingWindow: retargetingSegment.retargetingWindow,
        eventType: retargetingSegment.eventType,
        eventSubtype: retargetingSegment.eventSubtype,
        parameterFilters: retargetingSegment.parameterFilters,
        parameterFilterOperator: retargetingSegment.parameterFilterOperator
    };
};
export const retargetingSegmentToRetargetingSegmentUpdatePayload = (retargetingSegment) => {
    return {
        ...retargetingSegmentToRetargetingSegmentCreationPayload(retargetingSegment),
        id: retargetingSegment.id,
        externalId: retargetingSegment.externalId,
        status: retargetingSegment.status,
        preferred: retargetingSegment.preferred
    };
};
export const segmentToUpdatePayload = (segment) => {
    return {
        id: segment.id,
        parent: segment.parent,
        externalId: segment.externalId,
        name: segment.label,
        description: segment.description,
        status: segment.status,
        preferred: segment.preferred
    };
};
export const isRetargetingSegment = (segment) => 
/* @ts-expect-error - (TS Upgrade: 5.7.3) - https://typescript.tv/errors/#ts7053 */
!!segment["retargetingType"];
/**
 * @param orgSegmentPreference: an org's recipe preference obtained from the frontend/adhering to OrgSegmentPreference.
 * @return: an equivalent object, formatted to the ServiceOrgSegmentPreference interface.
 */
export const orgSegmentPreferenceToServiceOrgSegmentPreference = (orgSegmentPreference) => {
    return {
        org_id: orgSegmentPreference.orgId,
        segment_id: orgSegmentPreference.segmentId,
        preferred: !!orgSegmentPreference.preferred
    };
};
/**
 * @param orgSegmentPreference: an org's recipe preference obtained from the frontend/adhering to OrgSegmentPreference.
 * @return: an equivalent object, formatted to the ServiceOrgSegmentPreference interface.
 */
export const serviceOrgSegmentPreferenceToOrgSegmentPreference = (orgSegmentPreference) => {
    return {
        orgId: orgSegmentPreference.org_id,
        segmentId: orgSegmentPreference.segment_id,
        preferred: orgSegmentPreference.preferred
    };
};
//# sourceMappingURL=segment.js.map